module.exports = __webpack_public_path__ + "static/32-8471f60e3e133e019739ee073ebfe9b2.jpg";